import { createWorkflowUpdatesChangeExtension } from './workflow-updates-change';

// Suppresses the /module_data/flags entry when only the flag itself changed —
// that change is already shown via the /module_data/abtest extension.
// Scoped to AB test activities only (checks for a /module_data/abtest change
// in the same changeset) to avoid suppressing rollout flag changes.
export const FLAGS_MODULE_SUPPRESS_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'flags-module-flag-suppress',
    suppress: true,
    predicate: ({ change, activity }) => {
      if (change.fieldPath !== '/module_data/flags') return false;
      const oldFlag = (change.oldValue as { flag?: string } | null)?.flag;
      const newFlag = (change.newValue as { flag?: string } | null)?.flag;
      if (!oldFlag || !newFlag || oldFlag === newFlag) return false;
      return (activity.changeSet?.changes ?? []).some(
        c => c.fieldPath === '/module_data/abtest',
      );
    },
    render: () => null,
  });
